module.exports = __webpack_public_path__ + "ba90be80089b25d304df01b377861174.jpg";